import styled, { css } from 'styled-components';
import { colors } from '@everlywell/leaves';
const linkPseudoStates = css`
  color: rgb(${props => props.theme.linkColor});

  &:hover {
    color: rgb(${props => props.theme.linkHoverColor});
    text-decoration: underline;
  }

  &:focus {
    color: rgb(${props => props.theme.linkFocusedColor});
    text-decoration: none;
    outline: none;

    &:active {
      color: rgb(${props => props.theme.linkHoverColor});
      text-decoration: none;
    }
  }

  &:active {
    color: rgb(${props => props.theme.linkHoverColor});
    text-decoration: none;
  }
`;

const Spinner = styled.div`
  @keyframes loading {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  animation: 0.5s infinite linear loading;
  border: 0.1rem solid ${colors.green5};
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
  content: '';
  display: block;
  height: 0.8rem;
  margin-left: -0.4rem;
  margin-top: -0.4rem;
  width: 0.8rem;
`;

export { linkPseudoStates, Spinner };
